import { AnyRoute, createRoute, redirect } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'

import { ClientUsersWrapper } from './ClientUsersWrapper'
import { clientUsersListRoute } from './Routes/ClientUsersList/routes'

export const routeClientUsersTree = <T extends AnyRoute>(rootRoute: T) => {
  const clientsUsersIndexRoute = createRoute({
    beforeLoad: async ({ context }) => {
      if (!context.accessibleRoutingFlags.clientUserRootAccess) {
        throw redirect({
          to: '/'
        })
      }
    },
    getParentRoute: () => rootRoute,
    path: routes.bank.clientUsers.index,
    component: ClientUsersWrapper
  })

  return clientsUsersIndexRoute.addChildren([
    clientUsersListRoute<typeof clientsUsersIndexRoute>(clientsUsersIndexRoute)
  ])
}
